// Dresses Formie's repeater rows as the design's "Ticket – Person N" accordion and keeps
// the total in step with the row count: the on-page figure, and the hidden `amount` field
// Formie's Stripe element mounts against (it needs a non-zero amount and re-mounts on
// `input`). The server recomputes the amount from the ticket entry on submit regardless.

const ROW_SELECTOR = '.fui-repeater-row';
const ADD_BUTTON_SELECTOR = '.fui-repeater-add-btn';
const AMOUNT_INPUT_SELECTOR = 'input[name$="[amount]"]';
const REMOVE_BUTTON_SELECTOR = '.fui-repeater-remove-btn';
const HEADING_CLASS = 'ci-row-heading';
const COLLAPSED_CLASS = 'ci-row-collapsed';
const ROW_INTRO = 'Please fill in your details to secure your registration.';

const formatAud = (amount) => `$${amount.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const decorateRow = (row, index, label, fixed) => {
    let heading = row.querySelector(`.${HEADING_CLASS}`);

    if (!heading) {
        heading = document.createElement('div');
        heading.className = HEADING_CLASS;

        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = `${HEADING_CLASS}__toggle`;
        toggle.addEventListener('click', () => row.classList.toggle(COLLAPSED_CLASS));

        heading.appendChild(toggle);

        const intro = document.createElement('p');
        intro.className = `${HEADING_CLASS}__intro`;
        intro.textContent = ROW_INTRO;

        row.prepend(heading, intro);
    }

    heading.querySelector('button').textContent = `${label} ${index + 1}`;

    if (fixed) {
        const remove = row.querySelector(REMOVE_BUTTON_SELECTOR);

        if (remove) {
            remove.remove();
        }
    }
};

const init = (wrapper) => {
    const price = parseFloat(wrapper.dataset.price) || 0;
    const label = wrapper.dataset.label || 'Person';
    const fixed = wrapper.dataset.fixed === '1';
    const total = wrapper.querySelector('[data-ticket-total]');
    const amountInput = wrapper.querySelector(AMOUNT_INPUT_SELECTOR);

    const refresh = () => {
        const rows = Array.from(wrapper.querySelectorAll(ROW_SELECTOR));

        rows.forEach((row, index) => decorateRow(row, index, label, fixed));

        const amount = price * rows.length;

        if (total) {
            total.textContent = formatAud(amount);
        }

        if (amountInput && amountInput.value !== amount.toFixed(2)) {
            amountInput.value = amount.toFixed(2);
            amountInput.dispatchEvent(new Event('input', { bubbles: true }));
        }

        if (fixed) {
            const add = wrapper.querySelector(ADD_BUTTON_SELECTOR);

            if (add) {
                add.hidden = true;
            }
        }
    };

    // Formie appends and removes rows by mutating the DOM; watching it is simpler and
    // more robust than hooking every repeater event it exposes.
    const observer = new MutationObserver((mutations) => {
        const rowChanged = mutations.some((mutation) => Array.from(mutation.addedNodes)
            .concat(Array.from(mutation.removedNodes))
            .some((node) => node.nodeType === Node.ELEMENT_NODE && node.matches(ROW_SELECTOR)));

        if (!rowChanged) {
            return;
        }

        const rows = wrapper.querySelectorAll(ROW_SELECTOR);

        // A newly added row opens; the ones before it close, as in the design.
        rows.forEach((row, index) => row.classList.toggle(COLLAPSED_CLASS, index < rows.length - 1));

        refresh();
    });

    observer.observe(wrapper, { childList: true, subtree: true });

    refresh();
};

// Called from the Vue root's mounted hook: Vue re-renders everything inside #app from
// its DOM template on mount, so anything grabbed earlier is a detached node.
export const initTicketRows = () => document.querySelectorAll('[data-ticket-rows]').forEach(init);
